// 869dcbykn — URL builder for the booking PDF download endpoint.
//
// The backend (`sporttia-service` `period.validator.js`) validates the
// `paper` query parameter as `Joi.string().allow('TICKET')`, which rejects
// empty strings. Therefore the contract is:
//   - No type (default A4 PDF): omit `paper` entirely.
//   - type === 'TICKET' (small ticket PDF): include `paper=TICKET`.
// Sending `paper=` (empty) produces the user-visible error
// "Error de validación: paper no puede estar vacío".
export function buildBookingPdfUrl(idBooking: number, type?: string): string {
    const base = `/bookings/${idBooking}.pdf`;
    return type ? `${base}?paper=${type}` : base;
}
